import { z } from 'zod';

export const OpenRoleSchema = z.object({
  title: z.string().min(1, 'role title is required'),
  desc: z.string().min(1, 'description is required'),
});

export type OpenRole = z.infer<typeof OpenRoleSchema>;
export const OpenRolesSchema = z.array(OpenRoleSchema);
